import check from "check-types";

const stringifyValue = (value) =>
  Array.isArray(value) ? value.map(String).join(" ") : value;

const formatEntries = (obj) =>
  Object.entries(obj).map(([label, value]) => {
    const v = stringifyValue(value);
    return `${label.replace(/_/g, " ").toUpperCase()}: ${v}`;
  });

const filterError = (errors) => {
  try {
    if (!errors || typeof errors !== "object") return [];

    // 401s are handled by the axios interceptor (token refresh); no message.
    if (errors.response && errors.response.status === 401) return [];

    const data = errors.response && errors.response.data;

    if (!data) return ["No network connectivity or Unknown error"];
    if (typeof data === "string") return [data];

    // { detail: "..." }
    if (data.detail) return [String(data.detail)];

    // { errors: "..." } | { errors: {...} } | { errors: [...] }
    if (data.errors !== undefined) {
      if (typeof data.errors === "string") return [data.errors];
      if (Array.isArray(data.errors)) return data.errors.map(String);
      if (check.object(data.errors)) return formatEntries(data.errors);
    }

    // Flat validation body, e.g. { account_no: "already exists" }
    if (check.object(data)) return formatEntries(data);

    return [];
  } catch (error) {
    return [];
  }
};

export default filterError;
